export default "__VITE_ASSET__ONiuhGyK__"